// The available optimized resolutions, try to keep it
// in order because it makes sense.
const optimizedSizes = ['1280x800', '1680x1050', '1920x1200'];

const iviseMap = {
  '1280x800': 'small',
  '1680x1050': 'medium',
  '1920x1200': 'large',
};

// Calculate the optimized size for this display
function getOptimizedSize() {
  let optimizedSize;
  for (let i = 0; i < optimizedSizes.length; i++) {
    const option = optimizedSizes[i].split('x');
    // Our option is greater than the window's width, use it
    if (window.innerWidth <= option[0]) {
      optimizedSize = option;
      break;
    }
  }

  return optimizedSize
    ? optimizedSize.join('x')
    : optimizedSizes[optimizedSizes.length - 1]; // Optimized size or the largest one
}

// Replace our custom templated string.
// NOTE: We will have a live resizer at some point. Not too far from now.
// but still need this for legacy support a little while longer.
export default function optimizePath(media) {
  const path = media.src;

  // Does it support imagevise urls?
  if ('resized_src_large' in media) {
    const size = getOptimizedSize();
    if (!iviseMap[size]) {
      return path;
    }

    const optimizedPath = media[`resized_src_${iviseMap[size]}`];
    if (optimizedPath.match(/^https?:/)) {
      return optimizedPath;
    }
    return location.protocol + '//' + location.host + optimizedPath;
  }

  // If the path contains [SIZE] we'll replace that with the dimensions.
  if (typeof path === 'string' && path.indexOf('[SIZE]') !== -1) {
    return path.replace('[SIZE]', getOptimizedSize());
  }

  // If nothing matched, just return the regular path.
  return path;
}
